import React from "react";
const SocialLinks = () => <section>hey i'm SocialLinks</section>;
export default SocialLinks;
